/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'alert';
const componentName = 'alert-config-grid-expander';
const prefix = `${moduleName}.${componentName}`;

export const columnTitleEvents = `${prefix}.columnTitleEvents`;
export const columnTitleMetrics = `${prefix}.columnTitleMetrics`;

export const ENGLISH = {
    [columnTitleEvents]: 'Event(s)',
    [columnTitleMetrics]: 'Metric(s)',
};
